<script>
export default {
  props: {
    message: {
      type: Object,
      required: true
    },
    isParent: {
      type: Boolean,
      default: false,
    }
  },

  computed: {
    trucatedText () {
      const maxLength = 42;

      if (this.message.text.length <= maxLength) {
        return this.message.text;
      }

      return this.message.text.slice(0, maxLength) + '...';
    },

    formattedText () {
      let messageText = this.message.text;

      if (!messageText) {
        return null;
      }

      messageText = messageText.replace(/((https?:\/\/)[^\s]+)/g, (url) => `<a href="${url}" target="_blank">${url}</a>`); // Hypertext link

      // Check for not being inside an <a ...>...</a>
      const notInsideAnchor = "(?![^<]*</a>)";

      messageText = messageText.replace(new RegExp("\\*([^*]+)\\*" + notInsideAnchor, "g"), '<b>$1</b>'); // Bold
      messageText = messageText.replace(new RegExp("_([^_]+)_" + notInsideAnchor, "g"), "<i>$1</i>"); // Italic
      messageText = messageText.replace(new RegExp("~([^~]+)~" + notInsideAnchor, "g"), "<s>$1</s>"); // Line through
      messageText = messageText.replace(new RegExp("```([^`]+)```" + notInsideAnchor, "g"), "<tt>$1</tt>"); // Monospaced

      return messageText;
    },

    isContact () {
      const vCardRegex = /^BEGIN:VCARD[\s\S]*END:VCARD$/i;
      return vCardRegex.test(this.message.text);
    },
  }
}
</script>

<template>
  <LeadAttendenceMessageContact
    v-if="message.type === 'text' && isContact"
    :message="message"
    :isParent="isParent"
  />
  <LeadAttendenceMessageAudio
    v-else-if="message.type === 'sounds' && message.file"
    :message="message"
    :isParent="isParent"
  />
  <LeadAttendenceMessageFile
    v-else-if="message.file"
    :message="message"
    :isParent="isParent"
  />
  <LeadAttendenceMessageGallery
    v-else-if="message.type === 'gallery' && message.files"
    :message="message"
  />
  <p
    v-else
    v-html="formattedText"
    class="message-plain-text mb-0"
    :class="{ 'message-plain-text-truncate': isParent }"
  ></p>
</template>

<style lang="scss" scoped>
  .message-plain-text {
    white-space: pre-wrap;
    word-break: break-word;
  }

  .message-plain-text-truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
